import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { PetitionPhoto } from '#src/app/pages/petitionDetails/shared/types';
import { useProcessedImage } from '#src/app/shared/hooks/image';

export function usePhoto(): PetitionPhoto | undefined {
	const {
		data: {
			petition: { photo },
		},
	} = usePetitionDetailsPageData();
	const photoSmall = useProcessedImage(photo?.petitionSmall);
	const photoMedium = useProcessedImage(photo?.petitionMedium);

	return useMemo(() => {
		if (!photoSmall || !photoMedium) return undefined;

		return {
			mobileUrl: photoSmall.url,
			url: photoMedium.url,
			processing: photoSmall.processing || photoMedium.processing,
			palette: photoSmall.palette,
		};
	}, [photoSmall, photoMedium]);
}
